import React from "react";
import PlaySvg from "../../svg/PlaySvg";
import "./playBtn.scss";
const PlayBtn = () => {
  return (
    <div className="play_btn">
      <PlaySvg />
    </div>
  );
};

export default PlayBtn;
